import { useEffect } from "react";

const GoogleAnalytics = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://www.googletagmanager.com/gtag/js?id=G-RLL9QP3SCJ`;
        script.async = true;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", "G-RLL9QP3SCJ");
    }, []);

    return null;
};

export default GoogleAnalytics;
